var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCevDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5161_60",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8478 0.760742H1.06728C0.743937 0.760742 0.563386 1.10215 0.763633 1.33522L6.15389 7.58556C6.30818 7.76447 6.60527 7.76447 6.7612 7.58556L12.1514 1.33522C12.3517 1.10215 12.1711 0.760742 11.8478 0.760742Z",
    fill: "#1EAAE7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5161_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 -2H-1V10H13V-2Z",
    fill: "#1EAAE7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCevDown);
export default __webpack_public_path__ + "static/media/cev-down.10c76bf46d95496b3c4397e62f199e55.svg";
export { ForwardRef as ReactComponent };